import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowCaretDown = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0  448 512"
      {...props}
    >
      <path d="" />
      <path
        fill="currentColor"
        d="M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
      />
    </SvgIcon>
  );
};
